import React from 'react';
import {Dialog, DialogTitle, DialogContent, DialogActions} from '@epic-ui/epic/src/index';
import {Message, Button} from 'epic-diesel-common';
import CheckBox from 'epic-diesel-form/src/components/form/CheckBox';
import AffiliateDialog from './AffiliateDialog';
import ConductDialog from './ConductDialog';
import {MapStateToProps, MapDispatchToProps, connect} from 'react-redux';
import {
    getIsEulasAccepted,
    getAffiliateAgreement,
    getConductAgreement
} from '../../selectors/eula.selectors';
import eulaActions from '../../actions/eula.actions';
import FormsyForm from 'epic-diesel-form/src/components/external/FormsyForm';

const spanStyle: React.CSSProperties = {
    color: '#0078f2'
};

const spiltSpanStyle: React.CSSProperties = {
    width: '20px'
};

interface StateProps {
    open: boolean;
    precheckAffiliate: boolean;
    precheckConduct: boolean;
}
interface DispatchProps {
    onAcknowledge: () => void;
}
type Props = StateProps & DispatchProps;

interface State {
    agreementChecked: boolean;
    conductChecked: boolean;
    agreementOpen: boolean;
    conductOpen: boolean;
}

const mapStateToProps: MapStateToProps<StateProps, {}, any> = state => ({
    open: !getIsEulasAccepted(state),
    precheckAffiliate: Boolean(getAffiliateAgreement(state).accepted),
    precheckConduct: Boolean(getConductAgreement(state).accepted)
});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, {}> = {
    onAcknowledge: eulaActions.acceptAgreements
};

class UpdatedAgreementDialog extends React.Component<Props, State> {
    state: State = {
        agreementChecked: this.props.precheckAffiliate || false,
        conductChecked: this.props.precheckConduct || false,
        agreementOpen: false,
        conductOpen: false
    };

    render() {
        return (
            <>
                <FormsyForm>
                    <Dialog open={this.props.open} style={{width: 620}}>
                        <DialogTitle>
                            <Message code="epic.affiliate.eula.updated_agreement_dialog.title" />
                        </DialogTitle>
                        <DialogContent>
                            <Message code="epic.affiliate.signup.code_of_conduct.body" />
                            <div style={{marginBottom: 20}} />
                            <CheckBox
                                name="affiliate"
                                value={this.state.agreementChecked}
                                onChange={this.handleChangeAgreement}>
                                <Message code="epic.affiliate.signup.code_of_conduct.acknowledge">
                                    <span onClick={this.setAgreementOpen(true)} style={spanStyle}>
                                        <Message code="epic.affiliate.signup.code_of_conduct.affiliate_agreement" />
                                    </span>
                                </Message>
                            </CheckBox>
                            <CheckBox
                                name="conduct"
                                value={this.state.conductChecked}
                                onChange={this.handleChangeConduct}>
                                <Message code="epic.affiliate.signup.code_of_conduct.acknowledge">
                                    <span onClick={this.setConductOpen(true)} style={spanStyle}>
                                        <Message code="epic.affiliate.signup.code_of_conduct.conduct" />
                                    </span>
                                </Message>
                            </CheckBox>
                        </DialogContent>
                        <DialogActions>
                            <Button
                                to="/logout"
                                isExternalUrl={true}
                                theme="dark"
                                priority="secondary">
                                <Message code="epic.affiliate.eula.updated_agreement_dialog.signout" />
                            </Button>
                            <span style={spiltSpanStyle} />
                            <Button
                                disabled={!this.isBothChecked()}
                                priority="secondary"
                                onClick={this.props.onAcknowledge}
                                type="submit"
                                theme="dark">
                                <Message code="epic.affiliate.common.ok" />
                            </Button>
                        </DialogActions>
                    </Dialog>
                </FormsyForm>
                <AffiliateDialog
                    open={this.state.agreementOpen}
                    onClose={this.setAgreementOpen(false)}
                />
                <ConductDialog open={this.state.conductOpen} onClose={this.setConductOpen(false)} />
            </>
        );
    }

    private handleChangeAgreement = (_, value: boolean) => {
        this.setState({agreementChecked: value});
    };

    private handleChangeConduct = (_, value: boolean) => {
        this.setState({conductChecked: value});
    };

    private isBothChecked() {
        return this.state.agreementChecked && this.state.conductChecked;
    }

    private setAgreementOpen = (value: boolean) => (event?: React.MouseEvent<HTMLSpanElement>) => {
        if (event) {
            event.stopPropagation();
        }

        this.setState({agreementOpen: value});
    };

    private setConductOpen = (value: boolean) => (event?: React.MouseEvent<HTMLSpanElement>) => {
        if (event) {
            event.stopPropagation();
        }

        this.setState({conductOpen: value});
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UpdatedAgreementDialog);
